<template>
  <div>
    <!--功能按钮组件页面-->
    <avue-crud :data="list" :option="tableOption" :page="page" @size-change="sizeChange" @current-change="currentChange" 
    @search-reset="searchReset" @row-click="showRow" @search-change="searchChange">
      <template slot="search">
        <el-form-item label="师傅信息">
          <el-input v-model="listQuery.condition" clearable placeholder="姓名/手机号码/真实姓名"/>
        </el-form-item>
        <el-form-item label="师傅认证">
          <el-select v-model="listQuery.isForeman" clearable  placeholder="请选择">
              <el-option label="已认证" value="1"></el-option>
              <el-option label="未认证" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="工种类型">
          <el-select v-model="listQuery.workTypeId" clearable  placeholder="请选择">
              <el-option v-for="workType in dic.workTypes" :key="workType.id" :value="workType.code" :label="workType.name" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="群组">
          <el-select v-model="listQuery.groupId" clearable  placeholder="请选择">
              <el-option v-for="group in dic.groups" :key="group.id" :value="group.id" :label="group.groupName" ></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot-scope="scope" slot="menuLeft">
         <el-button class="filter-item" :disabled = "totalStatus" size="mini" @click="getInfo" type="primary" icon="el-icon-info">查看详情</el-button>
         <el-button v-if="roleManager.addGroup" :disabled = "totalStatus" class="filter-item" size="mini" @click="addGroup" type="primary" icon="el-icon-s-grid">设置群组</el-button>
         <el-button v-if="roleManager.addBlack" :disabled = "totalStatus"  class="filter-item" size="mini" @click="addBlack" type="primary" icon="el-icon-s-custom">移入黑名单</el-button>
          <el-button class="filter-item" size="mini" @click="invitebtn" type="primary" icon="el-icon-s-custom">邀请师傅</el-button>
      </template>
       <template slot-scope="scope" slot="userId">
          <el-radio class="radio" v-model="radio.userId"  :label="scope.row.userId"></el-radio>
      </template>
    </avue-crud>
    <info ref="info"></info>
    <group ref="group" @refresh="refresh" :treeData="dic.groups"></group>
    <black ref="black" @refreshblack="refreshblack"></black>
    <invite ref="invite"></invite>
 </div>
</template>
<script>
    import {getCompanyWorkers} from '@/api/admin/workerUser'
    import {getDictList} from '@/api/admin/dict'
    import {fetchList} from '@/api/admin/groups'
    import waves from '@/directive/waves/index.js' // 水波纹指令
    import info from './info'
    import group from './group'
    import black from './black'
    import invite from './invite'
    import { objKeySort } from '@/util/ajaxsign'
    import '../../../styles/addProject.scss';
    export default {
        name: 'worker_list',
        components: {info,group,black,invite},
        directives: { waves },
        data() {
            return {
                list: [],
                radio : '',
                totalStatus : true,
                listLoading : false,
                dic:{
                  workTypes:[],
                  skillTips:[],
                  groups:[]
                },
                roleManager:{
                  addGroup:false,
                  addBlack:false
                },
                listQuery: {
                  current: 1,
                  size: 10,
                  condition : '',
                  isForeman:'',
                  workTypeId:'',
                  groupId:''
                },
                page: {
                  pageSizes: [10, 20, 50, 100],
                  currentPage: 1,
                  total: 0,
                  pageSize: 10
                },
                tableOption : {
                  addBtn : false,
                  refreshBtn : false,
                  columnBtn : true,
                  editBtn : true,
                  delBtn : true,
                  menu : false,
                  page:true,
                  border : true,
                  align:'center',
                  menuAlign:'center',
                  height : window.innerHeight - 280,
                  index:false,
                  column:[ {
                    label:'',
                    prop:'userId',
                    width:40,
                    solt:true
                  },
                  {
                    label:'姓名',
                    prop:'userName',
                    overHidden : true,
                  },{
                    label:'手机号码',
                    prop:'phone',
                    overHidden : true,
                  },{
                    label:'团队认证',
                    prop:'isForeman',
                    overHidden : true,
                    formatter: function(row){
                        return  row.isForeman ==1? '已认证' : '未认证'
                    }
                  },
                  {
                    label:'真实姓名',
                    prop:'cardUserName',
                    overHidden : true,
                  },{
                    label:'工种',
                    prop:'workTypeIds',
                    overHidden : true,
                    formatter: function(row){
                      switch (row.workTypeIds) {
                        case '1':
                            return "搬运工"
                          break;
                          case '2':
                            return "安装工"
                          break;
                          case '3':
                            return "补漆工"
                          break;
                          case '4':
                            return "维修工"
                          break;
                        default:
                          return ''
                          break;
                      }
                      }
                    }

                    ,{
                      label:'实名状态',
                      prop:'workerState',
                      formatter: function(row){
                        if(row.workerState == 1){
                          return "审核中";
                        }else if(row.workerState == 2){
                          return "已认证";
                        }else{
                          return "未认证";
                        }
                      }
                    },
                    {
                      label:'群组',
                      prop:'groupNames',
                      overHidden : true
                    }
                  ]
                },
                permissions : [], //权限数据
                infodata : '',
            }
        },
        created() {
          this.initDic();
          this.getList();
          this.permissions = JSON.parse(window.sessionStorage.getItem("userInfo")).permissions;
            for(var i=0;i<this.permissions.length;i++){
                if(this.permissions[i] == 'group_add_worker'){
                    this.roleManager.addGroup = this.permissions[i]
                }
                if(this.permissions[i] == 'add_worker_black'){
                    this.roleManager.addBlack = this.permissions[i]
                }
            }
        },
        methods: {
            //刷新列表操作
            formatterWorkType(workTypeIds){
                var  workTypeNames = '';
                if(workTypeIds&&workTypeIds.length>0){
                    workTypeIds.split(",").forEach(workerTypeId =>{
                        if(this.dic.workTypes){
                            this.dic.workTypes.forEach(workerType => {
                                if(workerType.id==workerTypeId){
                                    workTypeNames = workTypeNames + workerType.name +',';
                                }
                            })
                        }else{
                            return workTypeIds;
                        }

                    })
                }
                if(workTypeNames.length>0){
                    workTypeNames = workTypeNames.substring(0,workTypeNames.length-1);
                }
                return  workTypeNames;
            },
            initDic(){
              getDictList(objKeySort({code:"worktype"})).then(response => {
                  this.dic.workTypes = response.data.data.worktype;
                  console.log('this.dic.workTypes',this.dic.workTypes);
                  
              })
               getDictList(objKeySort({code:"worker_skill"})).then(response => {
                  this.dic.skillTips = response.data.data.worker_skill;
              })

              fetchList(objKeySort()).then(response => {
                  this.dic.groups = response.data.data;
              })
            },
            refresh(){
              this.totalStatus = true;
              this.radio.userId = '';
              this.getList();
            },

            refreshblack(){
              this.totalStatus = true;
              this.radio.userId = '';
              this.getList();
            },

            //获取列表数据
            getList() {
              let that=this
                that.listLoading = true;
                that.listQuery.isAsc = false;
                getCompanyWorkers(objKeySort(that.listQuery)).then(response => {
                  if(response.data.code==200&&response.data.data){
                    that.listLoading = false;
                    that.list.length=0;
                    that.list = response.data.data;
                    // that.list.forEach(data =>{
                    //   data.workTypeIds = that.formatterWorkType(data.workTypeIds);
                    // })
                    that.page.total = response.data.data.length;
                  }

                })
            },
            //点击列数据
            showRow(row){
                this.radio = row;
                this.infodata = row;
                if(row){
                  this.totalStatus = false;
                }else{
                  this.totalStatus = true;
                }
            },


            //清空
            searchReset(){
              this.listQuery={};
              this.listQuery.current = 1;
              this.listQuery.size = 20;
              this.getList();
            },

            //条数
            sizeChange(val) {
              this.listQuery.size = val;
              this.getList();
            },
            //页码
            currentChange(val) {
              this.listQuery.current = val;
              this.getList();
            },
            //搜索数据
            searchChange(){
              this.getList();
            },

            getInfo(){
              this.$refs.info.setUserId(this.radio,this.dic);
            },

            addGroup(){
              this.$refs.group.setData(this.radio.userId,this.infodata.urId,this.dic.groups,this.infodata.groupIds);
            },
            addBlack(){
                this.$refs.black.setUserId(this.radio.userId,this.infodata.urId,this.infodata.userName);
            },
            //邀请操作
            invitebtn(){
              this.$refs.invite.setsataus();
            }
        }
    }
</script>
<style lang="scss" scoped>

  .el-tag{
    border: 0!important;
    color: #666!important;
    background-color: transparent;
    font-size:14px;
  }
  .dialog-footer{
    margin-left: 0!important;
  }
  .filter-item1{
    width: auto;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    border: 0!important;
    margin-left: 0!important;
    margin-right: 22px;
  }
  .el-table__row:nth-child(even) {
    background-color: #F6F9FF!important;
  }
  .is-required{

  }
  /*.select_role{
    -height:100px;
  }*/
  .el-dialog__footer{
    -height:120px;
  }
  .p1{
    width:100% !important;
  }
  .part{
    position: relative;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .el-radio__label{
    display:none;
  }

</style>
